/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteSettingResponseContent
 */
export interface DeleteSettingResponseContent {
    /**
     * 
     * @type {string}
     * @memberof DeleteSettingResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the DeleteSettingResponseContent interface.
 */
export function instanceOfDeleteSettingResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteSettingResponseContentFromJSON(json: any): DeleteSettingResponseContent {
    return DeleteSettingResponseContentFromJSONTyped(json, false);
}

export function DeleteSettingResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteSettingResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DeleteSettingResponseContentToJSON(value?: DeleteSettingResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

